import Auth from '../api/auth';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';

const parseErrorCode = error => Promise.reject(error);

// Debounce flag to prevent multiple simultaneous redirects
// from concurrent 401 responses.
let isRedirecting = false;

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => {
      // If the API returns 401 (Unauthorized), the user session is invalid
      // (locked, expired, or revoked). Clear credentials and redirect to login.
      if (error?.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;
        deleteIndexedDBOnLogout();
        clearCookiesOnLogout();
        window.location.assign('/app/login');
        return new Promise(() => {}); // Halt further promise chain
      }
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
